{
  "version": 1,
  "asset_id": "d58c1797-f7cf-48a8-a320-9360f718caf1",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/d58c1797-f7cf-48a8-a320-9360f718caf1/hero-parts-1280.mp4",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/d58c1797-f7cf-48a8-a320-9360f718caf1/hero-parts-1280.mp4",
  "original_filename": "hero-parts-1280.mp4",
  "size": 3379691,
  "content_type": "video/mp4",
  "created_at": "2026-07-01T15:23:33Z"
}
